(function ($) {
	$(document).ready(function () {

		$('.brand-carousel-brand-wrap').each(function(){


			var slider_id = $(this).attr('data-brand-slider-id');
			var slider_class = ".brand-carousel-" + slider_id;
			var d_slides = $(this).attr('data-brand-slider-d-slides');
			var t_slides = $(this).attr('data-brand-slider-t-slides');
			var m_slides = $(this).attr('data-brand-slider-m-slides');

			$(slider_class).slick({
				dots: false,
				infinite: true,
				speed: 300,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: Number(d_slides),
				slidesToScroll: 1,
				arrows: false,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: Number(t_slides),
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: Number(m_slides),
							slidesToScroll: 1
						}
					},

					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
			$('.previous-button.slider-' + slider_id).click(function () {
				console.log('clicked123');
				$(slider_class).slick('slickPrev');
			})
			$('.play-pause-button.slider-' + slider_id).click(function () {
				$('.pp-toggle').toggleClass('active');
				if ($('.pp-toggle.pause').hasClass('active')) {
					$(slider_class).slick('slickPlay');
				}
				if ($('.pp-toggle.play').hasClass('active')) {
					$(slider_class).slick('slickPause');
				}
			})
			$('.next-button.slider-' + slider_id).click(function () {
				$(slider_class).slick('slickNext');
			})
		})

	});
})(jQuery);
